import {
    setTransportStatus,
    setUserAgentStatus,
    setRegisterStatus,
    setConnectionError,
    setReconnectionFailed
} from 'store/actions/userAgent'
import { SessionState } from 'sip.js'
import { store, history } from 'store'
import { CallDirection, CallPageTypes, Events } from 'common/Enums'
import { setError } from 'store/actions/global'
import { UrlsProvider } from 'utils/urlUtils'
import * as callActions from 'store/actions/call'
import EventEmitter from './EventEmitter'
import { isEqual } from 'lodash-es'
import { navigateCallPage } from 'hooks'

const dispatch = store.dispatch

export default class WebphoneDelegate {
    constructor() {
        this.prevIncomingCall = null
        this.prevOutgoingCall = null
    }

    emitCallEvent(event, prevCallData, data) {
        // Prevent event emition when no data changed
        if(isEqual(data, prevCallData)) return

        prevCallData = data
        EventEmitter.emit(event, data)        
    }

    onRegistererStatus(status) {
        dispatch(setRegisterStatus(status))
    }

    onTransportStatus(status) {
        dispatch(setTransportStatus(status))
    }

    onUserAgentStatus(status) {
        dispatch(setUserAgentStatus(status))
    }

    onConnectionError(message) {
        message ? dispatch(setError(message)) : dispatch(setConnectionError(true))
    }

    onReconnectionFailed() {
        dispatch(setReconnectionFailed(true))
    }

    onOutgoingCall({ state, number, activeCalls, displayName, keepNumber }) {
        this.emitCallEvent(Events.OutgoingCall, this.prevOutgoingCall, { number, state, displayName })

        switch (state) {
            case SessionState.Initial:
                const { integration } = store.getState().profile
                const { integrationNumberSearch } = store.getState().settings

                if (integration && integration?.find_contact && integrationNumberSearch) {
                    dispatch(callActions.searchIntegrationNumber({ number, driver: integration.key }))
                }
                break
            case SessionState.Establishing:
                dispatch(
                    callActions.setupCall({
                        number,
                        direction: CallDirection.Outgoing,
                        activeCalls,
                        displayName
                    })
                )

                navigateCallPage({ activeCalls })
                break
            case SessionState.Established:
                dispatch(callActions.startCall({ number }))
                break
            case SessionState.Terminated:
                dispatch(callActions.endCall({ number, keepNumber }))
                navigateCallPage({ activeCalls })
                setTimeout(() => {
                    dispatch(callActions.removeCall({ number }))
                }, 1000)

                
                break
            default:
                break
        }
    }

    onIncomingCall({ state, number, activeCalls, displayName, isClick2Call, keepNumber }) {
        this.emitCallEvent(Events.IncomingCall, this.prevIncomingCall, {
            number,
            state,
            ...(displayName !== undefined && { displayName }),
            ...(isClick2Call !== undefined && { isClick2Call })
        })

        switch (state) {
            case SessionState.Initial:
                const { integration } = store.getState().profile
                const { integrationNumberSearch } = store.getState().settings

                if (integration && integration?.find_contact && integrationNumberSearch) {
                    dispatch(callActions.searchIntegrationNumber({ number, driver: integration.key }))
                }

                dispatch(
                    callActions.setupCall({
                        number,
                        direction: CallDirection.Incoming,
                        displayName,
                        isClick2Call
                    })
                )
                break
            case SessionState.Establishing:
                dispatch(
                    callActions.setupCall({
                        number,
                        direction: CallDirection.Incoming,
                        displayName,
                        isClick2Call
                    })
                )
                break
            case SessionState.Established:
                dispatch(callActions.startCall({ number }))
                navigateCallPage({ activeCalls })
                break
            case SessionState.Terminated:
                dispatch(callActions.endCall({ number,  keepNumber }))
                navigateCallPage({ activeCalls })
                setTimeout(() => {
                    dispatch(callActions.removeCall({ number }))
                }, 1000)
                break
            default:
                break
        }
    }

    onContinueCall() {
        history.push(UrlsProvider.callUrlGenerator(CallPageTypes.Single))
    }

    onHold({ number, value }) {
        dispatch(callActions.changeHold({ number, value }))
    }

    onMuteMic({ value, number }) {
        dispatch(callActions.changeMuteMic({ number, value }))
    }

    onChangeActive({ number }) {
        dispatch(callActions.changeActive({ number }))
    }

    onTransfer({ status, number }) {
        dispatch(callActions.callTransferredHandler({ number, status }))
    }

    onMerge({ numbers }) {
        history.push(UrlsProvider.callUrlGenerator(CallPageTypes.Single))
        dispatch(callActions.mergeCalls(numbers))
    }
}
